import React from 'react';
import type { Hero } from '@sy/ssr-types';
import { Translation } from '~/components/Translation';
import { HStack } from '~/components/ViewStacks';
import MobileLandingSignup from '~/scenes/Signup/scenes/MobileLandingSignup';
import SignupEmailPage from '~/scenes/Signup/scenes/SignupEmailPage';
import { CompetitorLogo } from '../CompetitorLogos';
import type { CompetitorType } from '../../types';
import {
	HeroContainer,
	HeroWrap,
	LeftSection,
	LogoWrapper,
	SignupWrap,
	Spacer,
	StyledLogo,
	Subtitle,
	Title,
	TitleHighlight,
	VsText,
} from './HeroSection.styled';

interface HeroSectionProps extends Hero {
	competitor?: CompetitorType;
}

const HeroSection: React.FC<HeroSectionProps> = ({
	titleKey,
	subtitleKey,
	competitor,
}) => {
	return (
		<>
			<HeroContainer>
				<HeroWrap>
					<LeftSection>
						<HStack spacing={8}>
							<LogoWrapper>
								<StyledLogo variant="icon" />
							</LogoWrapper>
							<VsText variant="h2">vs</VsText>
							{competitor && (
								<CompetitorLogo competitor={competitor} size={68} />
							)}
						</HStack>
						<Title variant="h1">
							{typeof titleKey === 'string' ? (
								<Translation tid={titleKey} />
							) : (
								<>
									<Translation tid={titleKey.part1} />
									<TitleHighlight>
										<Translation tid={titleKey.part2} />
									</TitleHighlight>
								</>
							)}
						</Title>
						{subtitleKey && (
							<Subtitle variant="body">
								<Translation tid={subtitleKey} />
							</Subtitle>
						)}
					</LeftSection>
					<Spacer />
					<SignupWrap>
						<SignupEmailPage isLandingPage isCustomLanding />
					</SignupWrap>
				</HeroWrap>
			</HeroContainer>
			<MobileLandingSignup gutterBottom />
		</>
	);
};

export default HeroSection;
